export default global.Image;



// WEBPACK FOOTER //
// ./src/Image.js